import { mergeProps } from "@base-ui-components/react/merge-props";
import * as React from "react";

/**
 * Minimal `asChild` slot: merges the wrapper's props onto its single element
 * child instead of rendering an extra node. Base UI's `mergeProps` does the
 * heavy lifting (composed event handlers, joined classNames, merged styles),
 * so this stays a cloneElement one-liner rather than a re-implementation of
 * Radix. Child props win on conflicts, matching Radix Slot semantics.
 */
export function Slot({
  children,
  ...props
}: React.HTMLAttributes<HTMLElement> & { children?: React.ReactNode }) {
  if (!React.isValidElement(children)) return null;
  const childProps = children.props as Record<string, unknown>;
  return React.cloneElement(
    children,
    mergeProps(props as Record<string, unknown>, childProps),
  );
}
